import React from "react";
import { Redirect } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import { withStyles } from '@mui/styles';

import DashboardTemplate from "../components/templates/DashboardTemplate";
import MixpanelOnload from "../components/MixpanelOnload";
import { Box, Button } from "@mui/material";
const moment = require('moment');

const useStyles = theme => ({
    '@global': {
    },
    paper: {
        padding: '8px',
        background: '#eeeeee',
    },
    sectionTitle: {
        color: '#FFFFFF',
        fontSize: '1.5rem',
        padding: '10px',
    },
    sectionBox: {
        background: '#7c7b7b',
        borderRadius: '10px',
    }
});

class Account extends React.Component {

    constructor() {
        super();
        this.state = {
            redirect: false,
            productName: "Loading",
            currentUnitCount: 10,
            currentPrice: 30,
            isOldPlan: false,
            stripe: null,
            hasPlan: true,
            isTrial: true,
            trialEndDate: moment(new Date().getTime() + 14 * 24 * 3600 * 1000).format('YYYY-MM-DD'),
            trialRemains: 14,
            hasPaymentMethod: false,
            card: {
                brand: '',
                last4: '',
                exp_month: '',
                exp_year: ''
            },
            stripeEmail: '',
            nextPaymentDate: '',
            discountPrice: 30,
        };
        this.getAccount = this.getAccount.bind(this);
        this.setCompletePayment = this.setCompletePayment.bind(this);
    }

    componentDidMount() {
        fetch("/api/getStripeKey")
            .then(res => res.json())
            .then(data => {
                if (data.key) {
                    const stripeJs = document.createElement('script');
                    stripeJs.src = 'https://js.stripe.com/v3/';
                    stripeJs.async = true;
                    stripeJs.onload = () => {
                        // The setTimeout lets us pretend that Stripe.js took a long time to load
                        // Take it out of your production code!
                        setTimeout(() => {
                            this.setState({
                                stripe: window.Stripe(data.key),
                            });
                        }, 500);
                    }
                    document.body && document.body.appendChild(stripeJs);
                }
            });

        this.getAccount();
    }

    getAccount() {
        fetch('/api/account')
            .then(res => res.json())
            .then(data => {
                // TODO set flags
                console.log(data);
                if (data.planType) {
                    this.setState({ card: data.card });
                    this.setState({ stripeEmail: data.stripeEmail });
                    this.setState({ nextPaymentDate: moment(data.nextPaymentTimestamp * 1000).format('YYYY-MM-DD') });
                    this.setState({ hasPlan: true });
                    this.setState({ planId: data.planId });
                    this.setState({ isTrial: data.isTrial });
                    this.setState({ trialEndDate: moment(data.trialEndTimestamp * 1000).format('YYYY-MM-DD') });
                    this.setState({ hasPaymentMethod: data.hasPaymentMethod });
                    this.setState({ productName: data.productName });
                    this.setState({ currentUnitCount: data.unitCount });
                    this.setState({ currentPrice: this.getTotalPrice(data.unitCount, false) })
                    this.setState({ isOldPlan: data.isOldPlan });
                    if (data.isOldPlan) {
                        if (data.planType === 1) {
                            this.setState({ discountPrice: 35 });
                        }
                        else {
                            this.setState({ discountPrice: 0 });
                        }
                    }
                    else {
                        if (data.unitCount >= 100) {
                            this.setState({ discountPrice: 2.4 * data.unitCount });
                        }
                        else {
                            this.setState({ discountPrice: 3 * data.unitCount });
                        }
                    }
                }
                else {
                    this.setState({ hasPlan: true });
                    this.setState({ hasPaymentMethod: data.hasPaymentMethod || false });
                    this.setState({ isTrial: true });
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ hasPlan: true });
                this.setState({ hasPaymentMethod: false });
                this.setState({ isTrial: true });
            })
    }

    setCompletePayment = () => {
        console.log(this);
        this.setState({
            completePayment: true,
            redirect: true,
        })
    }

    getTotalPrice = (unitCount, withDiscount = true) => {
        if (withDiscount && unitCount >= 100) {
            return unitCount * 240 / 100;
        }
        return unitCount * 3;
    }

    prependItems = () => {
        return <div>
            <Typography variant="h5" component="h2" align="center" marginTop="30px" marginBottom="30px">
                Account Info
            </Typography>
        </div>
    }
    appendItems = () => {
        return <></>
    }
    // no plan -> urges to select plan
    // no payment -> 
    // under trial -> shows period
    // under free plan -> 
    render() {
        const { classes } = this.props;
        const { redirect } = this.state;
        const { card, nextPaymentDate, hasPaymentMethod } = this.state;
        const { productName, isOldPlan, currentUnitCount, currentPrice } = this.state;
        if (redirect) {
            return <Redirect to="/change-finish" >
            </Redirect>
        }
        return (
            <DashboardTemplate maxWidth="md" prependItems={this.prependItems()} appendItems={this.appendItems()}>
                <CardContent style={{ width: '100%' }}>
                    <Box className={classes.sectionBox} marginTop="60px">
                        <h3 className={classes.sectionTitle}>Your Plan</h3>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <p>
                                <label>Current Plan: </label>
                                {productName}
                            </p>
                            {isOldPlan || productName === 'Small_Yearly' || productName === 'Business_Yearly' || productName === 'Enterprise_Yearly' ?
                                <span></span>
                                :
                                <>
                                    <p>
                                        <label>User Count: </label>
                                        {currentUnitCount}
                                    </p>
                                    <p>
                                        <label>Monthly payment: </label>
                                        ${currentPrice}
                                    </p>
                                </>

                            }

                        </Box>
                        <Button
                            variant={"outlined"}
                            style={{
                                backgroundColor: "transparent",
                                color: "#FF2B01",
                                borderColor: "#FF2B01",
                            }}
                            href="/change-plan"
                        >
                            Change

                        </Button>
                    </Box>
                    <Box className={classes.sectionBox} marginTop="60px">
                        <h3 className={classes.sectionTitle}>Payment Information</h3>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {hasPaymentMethod ?
                            <div><p>
                                {card.brand}&nbsp;
                                **** **** **** {card.last4}&nbsp;
                                {card.exp_month}/{card.exp_year}
                            </p>
                                <p>
                                    Next payment due:&nbsp;
                                    {nextPaymentDate}
                                </p></div> :
                            <p> No payment set </p>
                        }
                        <Button
                            variant={"outlined"}
                            style={{
                                backgroundColor: "transparent",
                                color: "#FF2B01",
                                borderColor: "#FF2B01",
                            }}
                            href="/change-payment"
                        >
                            Change

                        </Button>
                    </Box>
                    <Box className={classes.sectionBox} marginTop="60px">
                        <h3 className={classes.sectionTitle}>Cancellation</h3>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <p>Do you want to cancel your subscribe?</p>
                        <Button
                            variant={"outlined"}
                            style={{
                                backgroundColor: "transparent",
                                color: "#FF2B01",
                                borderColor: "#FF2B01",
                            }}
                            href="https://www.getkiara.com/contact"
                        >
                            Cancel
                        </Button>
                    </Box>
                </CardContent>
                <MixpanelOnload message="kiara-app.com/setup-payment" />
            </DashboardTemplate >
        )
    }
}
export default withStyles(useStyles)(Account);
